'use strict'

var drain = require('./drain')

module.exports = function log (done) {
  return drain(function (data) {
    console.log(data)
  }, done)
}



//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sinks/log.js
// module id = 775
// module chunks = 0